$(document).ready(function () {

  $(document).on('click', '.companies-annual-goals-list-component .objective', function () {
    const objectiveKeyResultParent = $(this).closest('.objective-key-result');
    const keyResultsParent = $(this).closest('.objective-key-result').find('.key-results');
    const editLink = $(this).closest('.objective-key-result').find('.edit-objective-key-result')
    const arrowDown = $(this).find('.fa-caret-down');

    // Toggle hidden key results
    const keyResult = objectiveKeyResultParent.find('.key-result')
    if (!arrowDown.hasClass('d-none')) {
      keyResult.removeClass('d-none');
      keyResultsParent.addClass('mb-4');
      arrowDown.addClass('d-none');
      editLink.removeClass('d-none');
    }
    else {
      keyResult.addClass('d-none');
      keyResultsParent.removeClass('mb-4');
      editLink.addClass('d-none');
      arrowDown.removeClass('d-none');
    }
  })

  $(document).on('mouseover', '.companies-annual-goals-list-component .objective', function () {
    const arrowDown = $(this).find('.fa-caret-down');

    // Fill arrow on hover
    arrowDown.addClass('fa-solid');
    arrowDown.removeClass('fa-regular');
  })
  $(document).on('mouseout', '.companies-annual-goals-list-component .objective', function () {
    const arrowDown = $(this).find('.fa-caret-down');

    // Unfill arrow on mouse out
    arrowDown.removeClass('fa-solid');
    arrowDown.addClass('fa-regular');
  })
})